import { createFileRoute } from '@tanstack/react-router';

import { PortDetailPage } from '../admin/port/detail/PortDetailPage';

export const Route = createFileRoute('/_app/port/detail/$id')({
    component: PortDetailPage,
});
